import React from 'react';
import {
  DropdownLabel,
  HorizontalFlexContainer,
  VerticalFlexContainer
} from '../../../data-catalog-shared';

export interface LineageSubplaceDropdownLabelProps {
  readonly label: string;
  readonly children: JSX.Element;
}

export const LineageSuplaceDropdownLabelTestId = 'lineage-subplace-dropdown-label';

export function LineageSubplaceDropdownLabel(props: LineageSubplaceDropdownLabelProps): JSX.Element {
  return (
    <VerticalFlexContainer fillFlexParent={true}>
      <DropdownLabel>
        <HorizontalFlexContainer>
          <span data-tb-test-id={LineageSuplaceDropdownLabelTestId}>{props.label}</span>
        </HorizontalFlexContainer>
      </DropdownLabel>
      {props.children}
    </VerticalFlexContainer>
  );
}

